
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'appraisals-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        email: '',
        phone: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = async () => {
        await store.dispatch(
          Actions.UPDATE_APPRAISAL_FILTER,
          selectedItems.value
        );
        emit('type-selected', selectedItems.value);
      };

      const onReset = async () => {
        selectedItems.value = { phone: '', email: '' };
        await store.dispatch(
          Actions.UPDATE_APPRAISAL_FILTER,
          selectedItems.value
        );
        emit('reset', selectedItems.value);
      };

      const filter = computed(() => store.getters.getAppraisalsFilters || {});
      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_AREAS_LIST);

        if (filter.value?.phone) selectedItems.value.phone = filter.value.phone;
        if (filter.value?.email && filter.value.email !== 'undefined')
          selectedItems.value.email = filter.value.email;
        if (filter.value?.areaId && filter.value.areaId !== 'undefined')
          selectedItems.value.areaId = filter.value.areaId;
      });

      return {
        selectedItems,
        onSubmit,
        onReset,
        translate,
        areas: computed(() => store.getters.allListAreas),
      };
    },
  });
